import { defer } from 'rxjs';
import { find, mergeMap } from 'rxjs/operators';

import { ImportApi, ImportState } from '~/api/import';

export interface ImportAnalysis {
  fileName: string;
  importType: string;
  submission: string;
  fileIdentity: string;
  dataRows: number;
  error: string;
}

class ImportServiceClass {
  importFile(file: any) {
    return defer(() => ImportApi.upload(file));
  }

  getQueue() {
    return defer(() => ImportApi.getAll());
  }

  isImporting() {
    return this.getQueue().pipe(
      mergeMap(async (x) => x),
      find(({ state }) => state == ImportState.Waiting || state == ImportState.Active)
    );
  }

  analyze(file: any) {
    return defer(() => ImportApi.analyze(file));
  }

  delete(id: number) {
    return defer(() => ImportApi.deleteById(id));
  }
}

export const ImportService = new ImportServiceClass();
